import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=65afb538&scoped=true&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"
import style0 from "./editor.vue?vue&type=style&index=0&id=65afb538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afb538",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Verification: require('/var/jenkins_home/workspace/prod-web-xfans/components/verificationCode/verification.vue').default})
